import PropTypes from 'prop-types';

import { DSIcon } from '../../../../base';

import styles from './ResponseRateIcon.module.scss';

const LEVEL_CLASS = {
  4: 'response-rate-icon--high',
  3: 'response-rate-icon--medium',
  2: 'response-rate-icon--low'
};

const ResponseRateIcon = ({ state }) => (
  <span className={styles[LEVEL_CLASS[state]]}>
    <DSIcon name="quick_phrases" />
  </span>
);

ResponseRateIcon.propTypes = {
  state: PropTypes.oneOf([2, 3, 4]).isRequired
};

export default ResponseRateIcon;
